var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEyeOff(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_30258_22617)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9593 11.9574C10.8197 12.8261 9.43209 13.3073 7.99935 13.3307C3.33268 13.3307 0.666016 7.9974 0.666016 7.9974C1.49528 6.45199 2.64544 5.1018 4.03935 4.0374M6.59935 2.82406C7.05824 2.71665 7.52806 2.66296 7.99935 2.66406C12.666 2.66406 15.3327 7.9974 15.3327 7.9974C14.928 8.75447 14.4454 9.46722 13.8927 10.1241M9.41268 9.41073C9.22958 9.60723 9.00878 9.76483 8.76345 9.87414C8.51812 9.98346 8.25328 10.0422 7.98474 10.047C7.7162 10.0517 7.44946 10.0023 7.20042 9.90172C6.95139 9.80113 6.72516 9.65142 6.53525 9.4615C6.34533 9.27158 6.19561 9.04536 6.09502 8.79632C5.99443 8.54729 5.94503 8.28054 5.94977 8.012C5.95451 7.74346 6.01329 7.47863 6.1226 7.23329C6.23191 6.98796 6.38952 6.76716 6.58602 6.58406M0.666016 0.664062L15.3327 15.3307",
    stroke: "#818181",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_30258_22617"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOff);
export default __webpack_public_path__ + "static/media/eye-off.e421ad0571735c6966f73d348a879f35.svg";
export { ForwardRef as ReactComponent };